import { render, staticRenderFns } from "./FileLock.vue?vue&type=template&id=3c8eeed4"
import script from "./FileLock.vue?vue&type=script&lang=js"
export * from "./FileLock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports